require('./sca.scss');

// @vendors
const PropTypes = require('prop-types');
const React = require('react');

// @commons
const { EmptyState } = require('commonsComponents/emptyState');

// @components
const { OKButton } = require('components/commons/OKButton/OKButton');
const ScaDisclaimerModal = require('components/sca/scaDisclaimerModal/scaDisclaimerModal');
const ScaRequestModal = require('components/sca/scaRequestModal/scaRequestModal');

// @helpers
const { FormattedText } = require('core/i18n').i18n;
const { getPhoneNumber } = require('utilities/personalDataHelper');

// @constants
const { OTP_VITUAL_OFFICE_CHECK } = require('constants/flagBasedFeatures');

// @ utilities
const {
    getStringFromVOandTrustedDevice
} = require('utilities/signaturePatternHelper');

class Sca extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            newMovementsRequest: false,
            scaDisclaimerModalVisible: false,
            scaRequestModalVisible: false,
        };

        this.buildEmptySection = this.buildEmptySection.bind(this);
        this.buildModalsSection = this.buildModalsSection.bind(this);
        this.getTitleAndDescription = this.getTitleAndDescription.bind(this);
        this.handlePrimaryButtonScaDisclaimerClick = this.handlePrimaryButtonScaDisclaimerClick.bind(this);
        this.handlePrimaryButtonScaRequestClick = this.handlePrimaryButtonScaRequestClick.bind(this);
        this.handleToggleScaDisclaimerModal = this.handleToggleScaDisclaimerModal.bind(this);
        this.handleToggleScaRequestModal = this.handleToggleScaRequestModal.bind(this);
        this.newMovementsRequest = this.newMovementsRequest.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        const { immTransactions, isPreview } = props;
        const { newMovementsRequest, scaDisclaimerModalVisible } = state;
        const empty = immTransactions.get('byOrder').size === 0;
        const scaRequired = immTransactions.get('scaRequired');
        return (newMovementsRequest && scaRequired && !empty && !isPreview && !scaDisclaimerModalVisible)
            ? {
                newMovementsRequest: false,
                scaRequestModalVisible: false,
                scaDisclaimerModalVisible: true,
            }
            : null;
    }

    getTitleAndDescription(pushKey, genericKey, smsKey) {
        const {
            flagBasedFeatures,
            immSignaturePatternVirtualOffices,
        } = this.props;
        let string;

        if (!!flagBasedFeatures && !!immSignaturePatternVirtualOffices) {
            string = getStringFromVOandTrustedDevice(
                flagBasedFeatures.get(OTP_VITUAL_OFFICE_CHECK),
                immSignaturePatternVirtualOffices,
                {
                    push: pushKey,
                    generic: genericKey,
                    sms: smsKey
                }
            )
        }

        return string;
    }

    newMovementsRequest() {
        this.setState({ newMovementsRequest: true });
    }

    buildEmptySection() {
        const scaRequestMessage = <FormattedText value="accounts-scaRequiredmessage" className="account-last-movements-content__sca-request" /> ;
        const viewMovementsButton = (
            <OKButton onClick={this.handleToggleScaRequestModal} >
                <FormattedText value="accounts-viewScaMovements" />
            </OKButton>
        );
        return (
            <EmptyState
                secondaryText={scaRequestMessage}
                button={viewMovementsButton}
                iconType="transfer-banking"
            />
        )
    }

    buildModalsSection(loading) {
        const { immProfile, showPN } = this.props;
        const { scaRequestModalVisible, scaDisclaimerModalVisible } = this.state;
        const phoneNumber = getPhoneNumber(immProfile);

        return (
            <React.Fragment>
                {
                    scaDisclaimerModalVisible &&
                    <ScaDisclaimerModal
                        onCloseCallback={this.handleToggleScaDisclaimerModal}
                        onPrimaryButtonClick={this.handlePrimaryButtonScaDisclaimerClick}
                        phone={phoneNumber}
                        visible={scaDisclaimerModalVisible}
                        getTitleAndDescription={this.getTitleAndDescription}
                        showPN={showPN}
                    />
                }
                {
                    scaRequestModalVisible && 
                    <ScaRequestModal
                        loading={loading}
                        visible={scaRequestModalVisible}
                        onCloseCallback={this.handleToggleScaRequestModal}
                        onPrimaryButtonClick={this.handlePrimaryButtonScaRequestClick}
                        phone={phoneNumber}
                        getTitleAndDescription={this.getTitleAndDescription}
                        showPN={showPN}
                    />
                }
                
            </React.Fragment>
        )
    }

    handlePrimaryButtonScaRequestClick() {
        const { onHandlePostRequest, validateAndExecuteSagas } = this.props;
        validateAndExecuteSagas(() => onHandlePostRequest())
    }

    handlePrimaryButtonScaDisclaimerClick() {
        this.setState({ 
            scaDisclaimerModalVisible: false,
            scaRequestModalVisible: true,
        } );
    }

    handleToggleScaDisclaimerModal() {
        const { scaDisclaimerModalVisible } = this.state;
        this.setState({ scaDisclaimerModalVisible: !scaDisclaimerModalVisible });
    }

    handleToggleScaRequestModal() {
        const { scaRequestModalVisible } = this.state;
        this.setState({ scaRequestModalVisible: !scaRequestModalVisible });
    }

    render() {
        const { immTransactions, isPreview } = this.props;
        const scaRequired = immTransactions.get('scaRequired');
        const loading = !immTransactions || immTransactions.get('loading');
        const empty = immTransactions.get('byOrder').size === 0;

        if (!scaRequired && !immTransactions.get('scaRequiredAccountModal')) return null;

        const emptySection = (isPreview || empty) ? this.buildEmptySection() : null;
        const modalsSection = this.buildModalsSection(loading);

        return (
            <React.Fragment>
                {emptySection}
                {modalsSection}
            </React.Fragment>
        );
    }
}

Sca.propTypes = {
    flagBasedFeatures: PropTypes.object,
    immProfile: PropTypes.object.isRequired,
    immSignaturePatternVirtualOffices: PropTypes.object,
    immTransactions: PropTypes.object,
    isPreview: PropTypes.bool,
    onHandlePostRequest: PropTypes.func.isRequired,
    showPN: PropTypes.bool,
    validateAndExecuteSagas: PropTypes.func.isRequired,
};

Sca.defaultProps = {
    isPreview: false,
    showPN: false
};

module.exports = Sca;

